import * as _4 from 'lodash4';
import { APCourse } from '../builders/ap_course_builder';
import { APPlannedCourse, IAPPlannedCourseMeta } from '../builders/ap_planned_course_builder';
import { ap_course_status_type } from '../strategies/ap_course_status_strategy';

export class APCourseServant {
  static isLockedByStatus(status: ap_course_status_type): boolean {
    return _4.includes(['REGISTERED', 'IN_PROGRESS', 'COMPLETED', 'SECTION_PICKED', 'WAITLISTED'], status);
  }
  static isDragEnabled(status: ap_course_status_type): boolean {
    return !_4.includes(['REGISTERED', 'COMPLETED', 'SECTION_PICKED'], status);
  }
  static courseOfferedProblemMessage() {
    return `This course is not typically offered in this term. See course details for more information.`;
  }
  static buildHoverTemplate(course: APCourse) {
    return `This course has requisite issues. See course details for more information.`;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/servants/ap_course_servant.ts